module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Change subscription plan","warning":"You are going to switch to "}}')
  delete Component.options._Ctor
}
